/**
 * activity redux constants
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */

// redux action IDs
export const START_ACTIVITY                 = 'START_ACTIVITY';
export const FINISH_ACTIVITY                = 'FINISH_ACTIVITY';
